import AxiosInstance from "./api";

export const AdvancePaymentRequestService = {
  getPaginate: async (payload) => {
    const query = new URLSearchParams(payload);
    return await AxiosInstance.get("/private/advance-payment-request", { params: query });
  },
  getById: async (id) => {
    return await AxiosInstance.get(`/private/advance-payment-request/${id}`);
  },
  create: async (payload) => {
    return await AxiosInstance.post("/private/advance-payment-request", payload);
  },
  update: async (id, payload) => {
    return await AxiosInstance.patch(`/private/advance-payment-request/${id}`, payload);
  },
  delete: async (id) => {
    return await AxiosInstance.delete(`/private/advance-payment-request/${id}`);
  },
};
